import { z } from 'zod'

export const WithBarcodeSchema = z.object({
    barcode: z.string().min(1),
})
